module.exports = __webpack_public_path__ + "img/9_10.ff75529b.png";